import { C } from '../data/constants.js';

export class Camera {
  constructor() {
    this.shakeX = 0;
    this.shakeY = 0;
    this.shakeIntensity = 0;
    this.shakeDuration = 0;
    this.shakeTimer = 0;

    // Slow-motion
    this.slowMo = 1.0;
    this.slowMoTarget = 1.0;
    this.slowMoLerpSpeed = 5.0;

    // Chromatic Aberration / Flash
    this.chromaticOffset = 0;
    this.chromaticTimer = 0;
    this.flashAlpha = 0;
  }

  shake(intensity, duration) {
    if (intensity >= this.shakeIntensity) {
      this.shakeIntensity = intensity;
      this.shakeDuration = duration;
      this.shakeTimer = duration;
    }
  }

  triggerSlowMo(factor, durationMs) {
    this.slowMo = factor;
    this.slowMoTarget = 1.0;
  }

  triggerChromaticAberration(offsetPx = 4, durationMs = 250) {
    this.chromaticOffset = offsetPx;
    this.chromaticTimer = durationMs;
  }

  triggerFlash(alpha = 0.4) {
    this.flashAlpha = alpha;
  }

  update(dtMs) {
    // Shake decay
    if (this.shakeTimer > 0) {
      this.shakeTimer -= dtMs;
      const progress = this.shakeTimer / this.shakeDuration;
      const currentIntensity = this.shakeIntensity * progress;
      this.shakeX = (Math.random() - 0.5) * 2 * currentIntensity;
      this.shakeY = (Math.random() - 0.5) * 2 * currentIntensity;
    } else {
      this.shakeX = 0;
      this.shakeY = 0;
      this.shakeIntensity = 0;
    }

    // Chromatic aberration decay
    if (this.chromaticTimer > 0) {
      this.chromaticTimer -= dtMs;
      if (this.chromaticTimer <= 0) {
        this.chromaticOffset = 0;
      }
    }

    // Flash decay
    if (this.flashAlpha > 0) {
      this.flashAlpha -= (dtMs / 1000) * 2.5;
      if (this.flashAlpha < 0) this.flashAlpha = 0;
    }

    // Slow-mo lerp
    if (this.slowMo !== this.slowMoTarget) {
      this.slowMo += (this.slowMoTarget - this.slowMo) * this.slowMoLerpSpeed * (dtMs / 1000);
      if (Math.abs(this.slowMo - this.slowMoTarget) < 0.01) {
        this.slowMo = this.slowMoTarget;
      }
    }
  }

  applyTransform(ctx) {
    ctx.save();
    ctx.translate(this.shakeX, this.shakeY);
  }

  restoreTransform(ctx) {
    ctx.restore();

    // Render flash overlay if active
    if (this.flashAlpha > 0) {
      ctx.fillStyle = `rgba(255, 255, 255, ${this.flashAlpha})`;
      ctx.fillRect(0, 0, C.CANVAS_W, C.CANVAS_H);
    }
  }
}
